/**
 * TabContextMenu — Right-click context menu for tabs.
 *
 * Shows: Rename, Delete (custom tabs only).
 * Positioned at mouse coordinates.
 */
import React, { useEffect, useRef } from 'react';

export default function TabContextMenu({ x, y, tab, onClose, onRename, onDelete }) {
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClick = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) onClose();
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, [onClose]);

    return (
        <div
            ref={menuRef}
            className="nw-context-menu"
            style={{ top: y, left: x }}
        >
            <button className="nw-context-item" onClick={onRename}>
                Rename
            </button>
            {!tab.isDefault && (
                <button
                    className="nw-context-item nw-context-item--danger"
                    onClick={onDelete}
                >
                    Delete Tab
                </button>
            )}
        </div>
    );
}
